module.exports = __webpack_public_path__ + "img/AAAI-500x500.fba9985d.png";